import intlMessagesEN from "./i18n/localization/en.json";
import intlMessagesVi from "./i18n/localization/vi.json";

export default {
  name: "NotificationClient",
  dir: "NotificationClient",
  pathRoot: "message",
  routes: [
    {
      url: "detail/:id",
      component: "Page/DetailNotif",
      layout: "FullLayout",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Thông báo - Tâm Trí Lực",
        titleI18n: "NotificationClient:title",
        exact: false,
      },
    },
    {
      url: "",
      component: "Page/index",
      layout: "FullLayout",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Thông báo - Tâm Trí Lực",
        titleI18n: "NotificationClient:title",
        exact: false,
      },
    },

  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: true,
};
